/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NbScrollStrategyOptions as ɵb} from './components/cdk/adapter/block-scroll-strategy-adapter';
export {NbPlatform as ɵd} from './components/cdk/platform/platform-service';
export {NbMenuInternalService as ɵa} from './components/menu/menu.service';
export {NbSharedModule as ɵc} from './components/shared/shared.module';